// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__28IdE","label":"Section_label__3AzHZ","contentWrap":"Section_contentWrap__1ChIV","footer":"Section_footer__2kJTL","footerInner":"Section_footerInner__3_-QA"};